"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("@superlogica/foundation/utils");

var CheckboxTheme = function CheckboxTheme(colorLabel, themeColors) {
  var _themeColors$colorLab;

  var neutralColor = (_themeColors$colorLab = themeColors[colorLabel]) !== null && _themeColors$colorLab !== void 0 ? _themeColors$colorLab : themeColors.textDefault;
  return {
    neutral: (0, _utils.parseColor)(neutralColor),
    error: (0, _utils.parseColor)(themeColors.danger),
    success: (0, _utils.parseColor)(themeColors.success)
  };
};

var _default = CheckboxTheme;
exports.default = _default;